import { Alert, Button, Checkbox, Col, Form, Input, InputNumber, Modal, Row, Select, Table } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { currencyFormat } from '../../Utils/formatCurrency';

function MinPurchaseProduct() {
    const token = useSelector((state) => state.user.token);
    const [form] = Form.useForm();

    const [data, setData] = useState([]);
    const [outlet, setOutlet] = useState([]);
    const [product, setProduct] = useState([]);
    const [variant, setVariant] = useState([]);

    const [outletValue, setOutletValue] = useState([]);
    const [dayValue, setDayValue] = useState([]);
    const [productValue, setProductValue] = useState(null);
    const [variantValue, setVariantValue] = useState(null);
    const [priceValue, setPriceValue] = useState(null);
    const [dataProduct, setDataProduct] = useState([]);

    const [searchProductTable, setSearchProductTable] = useState('');
    const [productPage, setProductPage] = useState({
        current: 1,
        pageSize: 5,
    });

    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);

    const [search, setSearch] = useState('');
    const [load, setLoad] = useState(0);

    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const titlePage = 'Min Purchase Product';

    const dayOptions = [
        { value: 'senin', label: 'Senin' },
        { value: 'selasa', label: 'Selasa' },
        { value: 'rabu', label: 'Rabu' },
        { value: 'kamis', label: 'Kamis' },
        { value: 'jumat', label: "Jum'at" },
        { value: 'sabtu', label: 'Sabtu' },
        { value: 'minggu', label: 'Minggu' },
    ];

    const filteredDataProduct = dataProduct.filter((item) => {
        const keyword = searchProductTable.toLowerCase();

        return (
            item.product_name?.toLowerCase().includes(keyword) ||
            item.variant_name?.toLowerCase().includes(keyword) ||
            item.SKU?.toLowerCase().includes(keyword)
        );
    });

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            render: (id, record, index) => {
                ++index;
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'Judul',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Deskripsi',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Minimal Pembelian',
            dataIndex: 'min_purchase',
            key: 'min_purchase',
            render: (text) => text ? currencyFormat(text) : '-',
        },
        {
            title: 'Tanggal Mulai',
            dataIndex: 'start_date',
            key: 'start_date',
        },
        {
            title: 'Tanggal Selesai',
            dataIndex: 'end_date',
            key: 'end_date',
        },
        {
            title: 'Jam Mulai',
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: 'Jam Selesai',
            dataIndex: 'end_time',
            key: 'end_time',
        },
        {
            title: 'Hari',
            key: 'days',
            render: (text, record) => {
                if (!record.min_purchase_days || record.min_purchase_days.length === 0) {
                    return '-';
                }

                return record.min_purchase_days
                    .map((item) => {
                        const found = dayOptions.find((day) => day.value === item.day);
                        return found ? found.label : item.day;
                    })
                    .join(', ');
            },
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            key: 'is_active',
            render: (text) => text === true ? 'Aktif' : 'Tidak Aktif',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                            <b style={{ marginLeft: 5 }}>Ubah</b>
                        </Button>
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                            <b style={{ marginLeft: 5 }}>Hapus</b>
                        </Button>
                    </>
                );
            },
        },
    ];

    const columnsProduct = [
        {
            title: 'No',
            render: (text, record, index) => {
                return (productPage.current - 1) * productPage.pageSize + index + 1;
            },
        },
        {
            title: 'Nama Produk',
            dataIndex: 'product_name',
            key: 'product_name',
        },
        {
            title: 'Nama Varian',
            dataIndex: 'variant_name',
            key: 'variant_name',
            render: (text, record) => text || record.SKU || '-',
        },
        {
            title: 'Harga Tebus',
            dataIndex: 'price',
            key: 'price',
            render: (text) => Number(text) >= 0 ? currencyFormat(text) : '-',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button type="text" danger onClick={() => deleteProduct(record)}>
                        <CloseOutlined />
                    </Button>
                );
            },
        },
    ];

    useEffect(() => {
        getApi('GET', '/min-purchase?search=' + search + '&page=' + page.pagination.current, 'all');

        if (outlet.length === 0) {
            getApi('GET', '/outlet?nopage=true', 'outlet');
        }

        if (product.length === 0) {
            getApi('GET', '/selectproduct', 'product');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [load]);

    const getApi = (method, url, type, dataReqBody = null) => {
        setIsAlert(false);
        setLoading(true);

        const dataReq = {
            method: method,
            url: url,
            data: {
                data: dataReqBody,
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        };

        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                switch (type) {
                    case 'all':
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data,
                            },
                        });
                        setLoading(false);
                        break;

                    case 'outlet':
                        var item_outlet = res.data;
                        var rowOutlet = [];

                        for (let i = 0; i < item_outlet.length; i++) {
                            rowOutlet.push({
                                value: item_outlet[i].outlet_id,
                                label: item_outlet[i].outlet_name,
                            });
                        }

                        setOutlet(rowOutlet);
                        setLoading(false);
                        break;

                    case 'product':
                        var item_product = res.data.rows;
                        var rowProduct = [];

                        for (let i = 0; i < item_product.length; i++) {
                            rowProduct.push({
                                value: JSON.stringify(item_product[i]),
                                label: item_product[i].product_name,
                            });
                        }

                        setProduct(rowProduct);
                        setLoading(false);
                        break;

                    case 'insert':
                    case 'update':
                    case 'delete':
                        setIsAlert(true);
                        setTextAlert(res.message);
                        setLoad(load + 1);
                        setLoading(false);
                        setLoadingBtn(false);
                        closeModal();
                        break;

                    default:
                        setLoading(false);
                        setLoadingBtn(false);
                        break;
                }
            } else {
                setLoading(false);
                setLoadingBtn(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            setLoadingBtn(false);
            console.log(e.message);
        });
    };

    const selectData = (event, type) => {
        const json_arr = JSON.parse(event);

        if (type === 'product') {
            setProductValue(JSON.stringify(json_arr));

            const rowVariant = [];

            if (json_arr.variant_products && json_arr.variant_products.length > 0) {
                for (let i = 0; i < json_arr.variant_products.length; i++) {
                    rowVariant.push({
                        value: JSON.stringify(json_arr.variant_products[i]),
                        label: json_arr.variant_products[i].variant_name !== null
                            ? json_arr.variant_products[i].variant_name
                            : json_arr.variant_products[i].SKU,
                    });
                }
            }

            setVariant(rowVariant);
            setVariantValue(null);
        } else {
            setVariantValue(JSON.stringify(json_arr));
        }
    };

    const saveProduct = () => {
        if (productValue == null) {
            modalError('Produk kosong');
            return;
        }

        if (variantValue == null) {
            modalError('Varian kosong');
            return;
        }

        if (priceValue == null || Number(priceValue) < 0) {
            modalError('Harga tebus tidak boleh kosong / minus');
            return;
        }

        const prod = JSON.parse(productValue);
        const vari = JSON.parse(variantValue);

        const duplicate = dataProduct.find(
            item => Number(item.variant_product_id) === Number(vari.variant_product_id)
        );

        if (duplicate) {
            modalError('Produk ini sudah ditambahkan');
            return;
        }

        const row = {
            product_id: prod.product_id,
            product_code: prod.product_code,
            product_name: prod.product_name,
            variant_product_id: vari.variant_product_id,
            variant_name: vari.variant_name,
            SKU: vari.SKU,
            price: Number(priceValue),
        };

        setDataProduct([row, ...dataProduct]);
        setProductValue(null);
        setVariantValue(null);
        setPriceValue(null);
        setVariant([]);
        setProductPage({
            ...productPage,
            current: 1,
        });
    };

    const deleteProduct = (record) => {
        const row = dataProduct.filter(
            item => Number(item.variant_product_id) !== Number(record.variant_product_id)
        );

        setDataProduct(row);
        setProductPage({
            ...productPage,
            current: 1,
        });
    };

    const resetProductTable = () => {
        setSearchProductTable('');
        setProductPage({
            current: 1,
            pageSize: 5,
        });
    };

    const openModal = (type, data) => {
        resetProductTable();

        if (type === 'edit') {
            setDataModal(data);

            const ev = {
                title: data.title,
                description: data.description,
                min_purchase: data.min_purchase,
                start_date: data.start_date,
                end_date: data.end_date,
                start_time: data.start_time,
                end_time: data.end_time,
                is_active: data.is_active,
            };

            if (data.min_purchase_outlets && data.min_purchase_outlets.length > 0) {
                const rowOutlet = data.min_purchase_outlets.map((o) => o.outlet_id);
                setOutletValue(rowOutlet);
                ev.outlets = rowOutlet;
            } else {
                setOutletValue([]);
                ev.outlets = [];
            }

            if (data.min_purchase_days && data.min_purchase_days.length > 0) {
                const rowDays = data.min_purchase_days.map((d) => d.day);
                setDayValue(rowDays);
                ev.days = rowDays;
            } else {
                setDayValue([]);
                ev.days = [];
            }

            if (data.min_purchase_items && data.min_purchase_items.length > 0) {
                const rowProduct = [];

                for (let i = 0; i < data.min_purchase_items.length; i++) {
                    const item = data.min_purchase_items[i];

                    rowProduct.push({
                        product_id: item.product_id,
                        product_code: item.product?.product_code,
                        product_name: item.product?.product_name,
                        variant_product_id: item.variant_product_id,
                        variant_name: item.variant_product?.variant_name,
                        SKU: item.variant_product?.SKU,
                        price: item.price,
                    });
                }

                setDataProduct(rowProduct);
            } else {
                setDataProduct([]);
            }

            setProductValue(null);
            setVariantValue(null);
            setPriceValue(null);
            setVariant([]);

            form.setFieldsValue(ev);
            setIsModal(true);
        } else {
            setDataModal(null);
            setOutletValue([]);
            setDayValue([]);
            setProductValue(null);
            setVariantValue(null);
            setPriceValue(null);
            setVariant([]);
            setDataProduct([]);
            form.resetFields();
            form.setFieldsValue({
                is_active: true,
                outlets: [],
                days: [],
            });
            setIsModal(true);
        }
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Anda ingin menghapus data ini?',
            onOk: () => getApi('DELETE', '/min-purchase/' + v.min_purchase_product_id, 'delete'),
        });
    };

    const onFinish = (ev) => {
        if (outletValue.length === 0) {
            modalError('Outlet kosong');
            return;
        }

        if (dayValue.length === 0) {
            modalError('Hari kosong');
            return;
        }

        if (dataProduct.length === 0) {
            modalError('Produk bonus kosong');
            return;
        }

        setLoadingBtn(true);

        const payload = {
            title: ev.title,
            description: ev.description,
            min_purchase: ev.min_purchase,
            start_date: ev.start_date,
            end_date: ev.end_date,
            start_time: ev.start_time,
            end_time: ev.end_time,
            is_active: ev.is_active,

            days: dayValue,

            outlets: outletValue.map((id) => ({
                outlet_id: id,
            })),

            items: dataProduct.map((item) => ({
                product_id: item.product_id,
                variant_product_id: item.variant_product_id,
                price: item.price,
            })),
        };

        if (dataModal !== null) {
            payload.min_purchase_product_id = dataModal.min_purchase_product_id;

            getApi(
                'PUT',
                '/min-purchase/' + dataModal.min_purchase_product_id,
                'update',
                payload
            );
        } else {
            getApi('POST', '/min-purchase', 'insert', payload);
        }
    };

    const closeModal = () => {
        setDataModal(null);
        setIsModal(false);
        setOutletValue([]);
        setDayValue([]);
        setProductValue(null);
        setVariantValue(null);
        setPriceValue(null);
        setVariant([]);
        setDataProduct([]);
        resetProductTable();
        form.resetFields();
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        setLoad(load + 1);
    };

    const handleTableChange = (pagination) => {
        setPage({
            pagination,
        });
        setLoad(load + 1);

        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}

            <h3>Daftar Min Purchase Product</h3>

            <Row>
                <Col span={6}>
                    <Search
                        placeholder="Pencarian"
                        allowClear
                        enterButton="Search"
                        size="medium"
                        onSearch={searchData}
                    />
                </Col>

                <Col span={18} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        disabled={loadingBtn}
                        style={{ marginBottom: 10 }}
                        type="primary"
                        onClick={() => openModal('add', null)}
                    >
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Tambah</b>
                    </Button>
                </Col>
            </Row>

            <Table
                size="middle"
                rowKey="min_purchase_product_id"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={page.pagination}
                onChange={handleTableChange}
            />

            <Modal
                title="Form Min Purchase Product"
                open={isModal}
                onOk={form.submit}
                onCancel={() => closeModal()}
                okText="Save"
                width={900}
                confirmLoading={loadingBtn}
            >
                <Form
                    form={form}
                    name="form_min_purchase_product"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="title"
                        label="Judul"
                        rules={[{ required: true, message: 'Judul harus diisi!' }]}
                    >
                        <Input placeholder="Masukkan judul" />
                    </Form.Item>

                    <Form.Item name="description" label="Deskripsi">
                        <Input.TextArea rows={3} placeholder="Masukkan deskripsi" />
                    </Form.Item>

                    <Form.Item
                        name="min_purchase"
                        label="Minimal Pembelian"
                        rules={[{ required: true, message: 'Minimal pembelian harus diisi!' }]}
                    >
                        <InputNumber
                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                            style={{ width: '100%' }}
                            placeholder="Masukkan minimal pembelian"
                        />
                    </Form.Item>

                    <Form.Item name="outlets" label="Pilih Outlet">
                        <Select
                            virtual={false}
                            mode="multiple"
                            showSearch
                            placeholder="Pilih Outlet"
                            optionFilterProp="label"
                            options={outlet}
                            value={outletValue}
                            onChange={(ev) => {
                                setOutletValue(ev);
                                form.setFieldsValue({ outlets: ev });
                            }}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                    <Form.Item name="days" label="Pilih Hari">
                        <Select
                            virtual={false}
                            mode="multiple"
                            showSearch
                            placeholder="Pilih Hari"
                            optionFilterProp="label"
                            options={dayOptions}
                            value={dayValue}
                            onChange={(ev) => {
                                setDayValue(ev);
                                form.setFieldsValue({ days: ev });
                            }}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                    <Row style={{ marginBottom: 8, alignItems: 'center' }}>
                        <Col span={12}>
                            <p style={{ marginBottom: 0 }}>Produk Tebus Murah</p>
                        </Col>

                        <Col span={12}>
                            <Search
                                placeholder="Cari produk / varian / SKU"
                                allowClear
                                size="medium"
                                value={searchProductTable}
                                onSearch={(value) => {
                                    setSearchProductTable(value);
                                    setProductPage({
                                        ...productPage,
                                        current: 1,
                                    });
                                }}
                                onChange={(e) => {
                                    setSearchProductTable(e.target.value);
                                    setProductPage({
                                        ...productPage,
                                        current: 1,
                                    });
                                }}
                            />
                        </Col>
                    </Row>

                    <Row gutter={8}>
                        <Col span={8}>
                            <Select
                            virtual={false}
                                showSearch
                                placeholder="Pilih Produk"
                                optionFilterProp="label"
                                options={product}
                                value={productValue}
                                onChange={(ev) => selectData(ev, 'product')}
                                style={{ width: '100%' }}
                            />
                        </Col>

                        <Col span={8}>
                            <Select
                            virtual={false}
                                showSearch
                                placeholder="Pilih Varian"
                                optionFilterProp="label"
                                options={variant}
                                value={variantValue}
                                onChange={(ev) => selectData(ev, 'variant')}
                                style={{ width: '100%' }}
                            />
                        </Col>

                        <Col span={5}>
                            <InputNumber
                                placeholder="Harga Tebus"
                                value={priceValue}
                                min={0}
                                onChange={(value) => setPriceValue(value)}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                style={{ width: '100%' }}
                            />
                        </Col>

                        <Col span={3}>
                            <Button block type="primary" onClick={() => saveProduct()}>
                                <PlusOutlined />
                            </Button>
                        </Col>
                    </Row>

                    <Table
                        style={{ marginTop: 10, marginBottom: 10 }}
                        size="small"
                        rowKey="variant_product_id"
                        columns={columnsProduct}
                        dataSource={filteredDataProduct}
                        pagination={{
                            current: productPage.current,
                            pageSize: productPage.pageSize,
                            total: filteredDataProduct.length,
                            showSizeChanger: true,
                            pageSizeOptions: ['5', '10', '20', '50'],
                            onChange: (current, pageSize) => {
                                setProductPage({
                                    current,
                                    pageSize,
                                });
                            },
                        }}
                    />

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="start_date" label="Tanggal Mulai">
                                <Input type="date" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="end_date" label="Tanggal Selesai">
                                <Input type="date" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="start_time" label="Jam Mulai">
                                <Input type="time" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="end_time" label="Jam Selesai">
                                <Input type="time" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item name="is_active" label="Status" valuePropName="checked">
                        <Checkbox>Aktif</Checkbox>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export default MinPurchaseProduct;